import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

/**
 * Storage pack — bytes, throughput, backup/versioning fields that apply
 * to storage-class resources (S3, EBS, EFS, RDS underlying storage).
 */
export const networkStorageFieldPack: FieldPack = {
  id: 'network-storage',
  name: 'Storage',
  description: 'Capacity, performance, backups, versioning',
  version: '1.0.0',
  dependencies: ['network-base'],
  fields: [
    {
      id: 'storageClass',
      label: 'Storage Class',
      type: FieldType.SELECT,
      tags: ['storage'],
      priority: 95,
      options: [
        { value: 'standard', label: 'Standard' },
        { value: 'infrequent', label: 'Infrequent Access' },
        { value: 'glacier', label: 'Glacier' },
        { value: 'intelligent-tiering', label: 'Intelligent Tiering' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'storageSize',
      label: 'Size (GB)',
      type: FieldType.NUMBER,
      tags: ['storage'],
      priority: 90,
      sensitivity: 'public',
    },
    {
      id: 'iops',
      label: 'IOPS',
      type: FieldType.NUMBER,
      tags: ['storage'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'throughputMbps',
      label: 'Throughput (MB/s)',
      type: FieldType.NUMBER,
      tags: ['storage'],
      priority: 80,
      sensitivity: 'internal',
    },
    {
      id: 'versioning',
      label: 'Versioning Enabled',
      type: FieldType.BOOLEAN,
      tags: ['storage'],
      priority: 75,
      sensitivity: 'public',
    },
    {
      id: 'backupRetention',
      label: 'Backup Retention (days)',
      type: FieldType.NUMBER,
      tags: ['storage'],
      priority: 70,
      sensitivity: 'internal',
    },
    {
      id: 'replication',
      label: 'Replication',
      type: FieldType.SELECT,
      tags: ['storage'],
      priority: 65,
      options: [
        { value: 'none', label: 'None' },
        { value: 'same-region', label: 'Same Region' },
        { value: 'cross-region', label: 'Cross Region' },
      ],
      sensitivity: 'internal',
    },
  ],
};
